import React, { useCallback, useMemo } from 'react';
import { TagsIcon, TagsKey } from '../contstants';
import { camelCase, startCase } from 'lodash';
import { ExpandableMenu, TagChip } from '../../components';
import { View } from '../../common';
import './conversation-tags.scss';
import { hash } from '@zonofi/common';
import { SVGS } from '../../assets';

interface ConversationTagsProps {
  customerLifeCyclePaths: string[];
  tags: string[];
  findTagType: (tag: string) => TagsKey;
  visibleCount?: number;
  onAddTag?: () => void;
  queryType?: string;
}

export const ConversationTags: React.FC<ConversationTagsProps> = ({
  customerLifeCyclePaths,
  tags,
  findTagType,
  visibleCount = 2,
  onAddTag,
  queryType,
}) => {
  const visibleTags = tags.slice(0, visibleCount);
  const additionalTags = tags.slice(visibleCount);

  const renderTagItem = useCallback((tag: string, idx: number) => {
    const tagKey = findTagType(tag);
    return (
      <div
        className={`conversation-tags-each conversation-tags-${tagKey} font-semibold`}
        key={`${idx}-${Math.random()}`}
      >
        {TagsIcon[tagKey]} {startCase(camelCase(tag))}
      </div>
    );
  }, []);

  const renderLifeCycleItem = useCallback((lifecycle: string, idx: number) => {
    const key = hash(lifecycle, 4);
    return (
      <div
        className={`conversation-tags-each lifecycle-tag-${key} font-medium`}
        key={idx}
      >
        {startCase(camelCase(lifecycle))}
      </div>
    );
  }, []);

  const renderQueryType = useCallback((queryType: string, idx: number) => {
    return (
      <div
        className={`conversation-tags-each conversation-tags-query-type font-semibold`}
        key={`${idx}-${queryType}`}
      >
        {queryType}
      </div>
    );
  }, []);

  const mainContent = useMemo(() => {
    const lifecycle = customerLifeCyclePaths.map((x, idx) =>
      renderLifeCycleItem(x, idx)
    );
    const tags: JSX.Element[] = [];
    if (queryType) tags.push(renderQueryType(queryType, -1));
    visibleTags.forEach((x, idx) => tags.push(renderTagItem(x, idx)));
    if (onAddTag) {
      tags.push(
        <span
          className="conversation-tags-each conversation-tags-add font-semibold"
          onClick={onAddTag}
        >
          <img src={SVGS.PlusIconNew} alt="" />
          Add Tag
        </span>
      );
    }
    //life cycle is not required yet
    return [...tags];
  }, [visibleCount, visibleTags]);

  const additionalItems = useMemo(() => {
    return additionalTags.map((x, idx) => ({
      id: `${idx}-${x}`,
      content: renderTagItem(x, idx),
    }));
  }, []);

  return (
    <ExpandableMenu
      mainContent={mainContent}
      additionalItems={additionalItems}
      triggerComponent={(count, onToggle) => (
        <View onPress={onToggle}>
          <TagChip tagName={`+${count}`} needTagIcon={false} variant="gray" />
        </View>
      )}
      className="conversation-tags"
      popupClassName="conversation-tags-popup"
      popupItemClassName="conversation-tags-popup-item"
    />
  );
};
